import { combineReducers } from 'redux';
import {
  application,
  applicationIsLoading,
  fatalError,
  availablePolicyTypes,
  potentialMailingAddresses,
  partner,
  industryName,
  acknowledgements,
  partnerFromApplication,
  existingApplicationLoaded,
  userHas,
  dbaIsValid,
  editedFromSummary,
  pl,
} from './application';

import {
  quote,
  purchasedPolicy,
  quoteBindPending,
  reasonabilityErrors,
  policyPurchaseErrors,
  paymentInterval,
  quoteIsLoading,
  declinations,
} from './quote';
import availableEndorsements from './availableEndorsements';
import { connectRoutes } from 'redux-first-router';
import { routePaths } from '../routing/routes';
import { agent } from './agent';
import { referralPartner } from './referralPartner';
import { businessInfo } from './businessInfo';

const { reducer: location } = connectRoutes(routePaths);

export default combineReducers({
  location,
  application,
  agent,
  applicationIsLoading,
  fatalError,
  quote,
  availablePolicyTypes,
  purchasedPolicy,
  quoteBindPending,
  potentialMailingAddresses,
  partner,
  reasonabilityErrors,
  declinations,
  industryName,
  policyPurchaseErrors,
  acknowledgements,
  paymentInterval,
  partnerFromApplication,
  referralPartner,
  quoteIsLoading,
  existingApplicationLoaded,
  userHas,
  availableEndorsements,
  dbaIsValid,
  editedFromSummary,
  pl,
  businessInfo,
});
